import type { State } from '../types.tsx';

export const isGroupReorderingEnabled = (state: State): boolean => state.isGroupReorderingEnabled;
export const isItemReorderingEnabled = (state: State): boolean => state.isItemReorderingEnabled;
export const isColumnResizingEnabled = (state: State): boolean => state.isColumnResizingEnabled;
export const isColumnReorderingEnabled = (state: State): boolean => state.isColumnReorderingEnabled;
export const isItemSelectionEnabled = (state: State): boolean => state.isItemSelectionEnabled;
